import { useCallback, useLayoutEffect, useState, type RefCallback } from 'react'

/**
 * Observes an element's height. Callback ref, not an object ref. A node that
 * appears after the first commit (login gate, late slot) still gets measured.
 */
export function useElementHeightObserver(
  onHeightChange: (height: number) => void,
  options: { observe?: boolean } = {},
): RefCallback<HTMLDivElement> {
  const { observe = true } = options
  const [node, setNode] = useState<HTMLDivElement | null>(null)
  const ref = useCallback<RefCallback<HTMLDivElement>>((element) => {
    setNode(element)
  }, [])

  useLayoutEffect(() => {
    if (!node) return

    onHeightChange(node.offsetHeight)

    if (!observe) return

    const ro = new ResizeObserver(() => {
      onHeightChange(node.offsetHeight)
    })
    ro.observe(node)

    return () => ro.disconnect()
  }, [node, onHeightChange, observe])

  return ref
}
